import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../assets/images/CustomerManagement/descToAsc.svg';
import SbActionDropdownButton from '../Buttons/SbActionDropdownButton';
import StatusBadgeWithDropdown from '../Buttons/StatusBadgeWithDropdown';
import SbFinancialStructureButton from '../Buttons/SbFinancialStructureButton';

const data = [
    {
        referenceKey: 'W',
        referenceType: 'work order',
        referenceNumber: '--',
        referenceDescription: '--',
        orgCode: '--',
        orgName: '--',
        assemblyItem: '--',
        assemblyItemDes: '--',
        component: '--',
        componentDes: '--',
        requiredQuantity: '--',
        uom: '--',
        quantityIssued: '--',
        quantityOpen: '--',
        controllingArea: '--',
        name: '--',
        startDate: '--',
        endDate: '--',
        companyCode: '--',
        costCategory: '--',
        plant: '--',
        city: '--',
        postalCode: '--',
        department: '--',
        demandStatus: '--',
        projectNetwork: '--',
        task: '--',
        taskName: '--',
        priority: 'Normal',
        Status: 'Open',
    },
    {
        referenceKey: 'K',
        referenceType: 'cost center',
        referenceNumber: '--',
        referenceDescription: '--',
        orgCode: '--',
        orgName: '--',
        assemblyItem: '--',
        assemblyItemDes: '--',
        component: '--',
        componentDes: '--',
        requiredQuantity: '--',
        uom: '--',
        quantityIssued: '--',
        quantityOpen: '--',
        controllingArea: '--',
        name: '--',
        startDate: '--',
        endDate: '--',
        companyCode: '--',
        costCategory: '--',
        plant: '--',
        city: '--',
        postalCode: '--',
        department: '--',
        demandStatus: '--',
        projectNetwork: '--',
        task: '--',
        taskName: '--',
        priority: 'Low',
        Status: 'Released',
    },
    {
        referenceKey: 'P',
        referenceType: 'WBS (project)',
        referenceNumber: '--',
        referenceDescription: '--',
        orgCode: '--',
        orgName: '--',
        assemblyItem: '--',
        assemblyItemDes: '--',
        component: '--',
        componentDes: '--',
        requiredQuantity: '--',
        uom: '--',
        quantityIssued: '--',
        quantityOpen: '--',
        controllingArea: '--',
        name: '--',
        startDate: '--',
        endDate: '--',
        companyCode: '--',
        costCategory: '--',
        plant: '--',
        city: '--',
        postalCode: '--',
        department: '--',
        demandStatus: '--',
        projectNetwork: '--',
        task: '--',
        taskName: '--',
        priority: 'Medium',
        Status: 'Close',
    },
    {
        referenceKey: 'N',
        referenceType: 'network',
        referenceNumber: '--',
        referenceDescription: '--',
        orgCode: '--',
        orgName: '--',
        assemblyItem: '--',
        assemblyItemDes: '--',
        component: '--',
        componentDes: '--',
        requiredQuantity: '--',
        uom: '--',
        quantityIssued: '--',
        quantityOpen: '--',
        controllingArea: '--',
        name: '--',
        startDate: '--',
        endDate: '--',
        companyCode: '--',
        costCategory: '--',
        plant: '--',
        city: '--',
        postalCode: '--',
        department: '--',
        demandStatus: '--',
        projectNetwork: '--',
        task: '--',
        taskName: '--',
        priority: 'High',
        Status: 'Draft',
    },
];

const columns = [
    { id: 'referenceKey', label: 'REFERENCE KEY', align: 'left', minWidth: '150px' },
    { id: 'referenceType', label: 'REFERENCE TYPE', align: 'left', minWidth: '160px' },
    { id: 'referenceNumber', label: 'REFERENCE NUMBER', align: 'left', minWidth: '180px' },
    { id: 'referenceDescription', label: 'REFERENCE DESCRIPTION', align: 'left', minWidth: '210px' },
    { id: 'orgCode', label: 'ORG CODE', align: 'left', minWidth: '120px' },
    { id: 'orgName', label: 'ORG NAME', align: 'left', minWidth: '120px' },
    { id: 'assemblyItem', label: 'ASSEMBLY ITEM', align: 'left', minWidth: '150px', },
    { id: 'assemblyItemDes', label: 'ASSEMBLY ITEM DES', align: 'left', minWidth: '180px', },
    { id: 'component', label: 'COMPONENT', align: 'left', minWidth: '130px', },
    { id: 'componentDes', label: 'COMPONENT DES', align: 'left', minWidth: '160px', },
    { id: 'requiredQuantity', label: 'REQUIRED QUANTITY', align: 'left', minWidth: '180px', },
    { id: 'uom', label: 'UOM', align: 'left', minWidth: '80px', },
    { id: 'quantityIssued', label: 'QUANTITY ISSUED', align: 'left', minWidth: '170px', },
    { id: 'quantityOpen', label: 'QUANTITY OPEN', align: 'left', minWidth: '150px', },
    { id: 'controllingArea', label: 'CONTROLLING AREA', align: 'left', minWidth: '180px', },
    { id: 'name', label: 'NAME', align: 'left', minWidth: '80px', },
    { id: 'startDate', label: 'START DATE', align: 'left', minWidth: '130px', },
    { id: 'endDate', label: 'END DATE', align: 'left', minWidth: '120px', },
    { id: 'companyCode', label: 'COMPANY CODE', align: 'left', minWidth: '160px', },
    { id: 'costCategory', label: 'COST CATEGORY', align: 'left', minWidth: '160px', },
    { id: 'plant', label: 'PLANT', align: 'left', minWidth: '90px', },
    { id: 'city', label: 'CITY', align: 'left', minWidth: '80px', },
    { id: 'postalCode', label: 'POSTAL CODE', align: 'left', minWidth: '140px', },
    { id: 'department', label: 'DEPARTMENT', align: 'left', minWidth: '140px', },
    { id: 'demandStatus', label: 'DEMAND STATUS', align: 'left', minWidth: '160px', },
    { id: 'projectNetwork', label: 'PROJECT / NETWORK # (OPTIONAL)', align: 'left', minWidth: '280px', },
    { id: 'task', label: 'TASK # (OPTIONAL)', align: 'left', minWidth: '180px', },
    { id: 'taskName', label: 'TASK NAME (OPTIONAL)', align: 'left', minWidth: '210px', },
    { id: 'priority', label: 'PRIORITY', align: 'left', minWidth: '120px', },
    { id: 'Status', label: 'STATUS', align: 'left', minWidth: '150px', },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const FinancialStructureMasterTable = (props) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const handleActionClick = (event, customer) => {
        setSelectedCustomer(customer);
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setActionAnchorEl(false);
    };

    const handleMenuItemClick = (action) => {
        if (action === 'edit') {
            console.log('Edit Details for:', selectedCustomer);
            // Implement edit functionality here
        } else if (action === 'view') {
            console.log('View Details for:', selectedCustomer);
            // Implement view functionality here
        }
        handleActionClose();
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = data.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [data, order, orderBy]);

    return (
        <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
            <Table>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                <div style={{ display: 'flex', alignItems: 'center' }} className='table-header-div'>
                                    {column.label}
                                    {column.sortable !== false && (
                                        <IconButton
                                            size="small"
                                            onClick={(event) => handleRequestSort(event, column.id)}
                                        >
                                            <img src={SortIcon} alt="Sort" />
                                        </IconButton>
                                    )}
                                </div>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedData.map((customer) => (
                        <TableRow key={customer.id}>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align}>
                                    {column.id === 'Status' ? (
                                        // <span
                                        // className={`status-badge-for-enabling ${customer.status === 'Enable' ? 'complete-status' : 'cancel-status'}`}
                                        // >
                                        //     {customer.status}&nbsp;&nbsp;&nbsp;&nbsp;
                                        //     <span className="dropdown-arrow">
                                        //         <img src={SortIcon} alt="dropdown icon" />
                                        //     </span>
                                        // </span>
                                        <SbFinancialStructureButton customer={customer} status={customer.Status} />
                                    ) : column.id === 'action' ? (
                                        <SbActionDropdownButton
                                            options={[{ type: 'Edit' }, { type: 'View' }, { type: 'Download' }, { type: 'Delete' }]}
                                            openAddModal={props.handleOpenModal}
                                            addBulkModel={props.handleOpenViewModal}
                                        />
                                    ) : column.id === 'referenceKey' ? (
                                        <span className="ssi-key-design">{customer[column.id]}</span>
                                    ) : (
                                        customer[column.id]
                                    )}
                                </TableCell>

                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem onClick={() => handleSortOrderChange('asc')}>
                    <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                    Ascending to Descending
                </MenuItem>
                <MenuItem onClick={() => handleSortOrderChange('desc')}>
                    <img src={descToAsc} alt="" />&nbsp;&nbsp;
                    Descending to Ascending
                </MenuItem>
            </Menu>
        </TableContainer>
    );
};

export default FinancialStructureMasterTable;
